import { render, staticRenderFns } from "./examResult.vue?vue&type=template&id=05b07986&scoped=true&"
import script from "./examResult.vue?vue&type=script&lang=js&"
export * from "./examResult.vue?vue&type=script&lang=js&"
import style0 from "./examResult.vue?vue&type=style&index=0&id=05b07986&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b07986",
  null
  
)

export default component.exports